<template>
  <div>
    <TopBarBackText title="친구 초대" />
    <div class="invite-page">
      <ImageMessageBlock
        image="/img/event/invite-friend.png"
        image-size="288"
      >
        <template #title>
          <div class="text-center">
            친구에게 1,000원<br />
            선물하세요!
          </div>
        </template>
        <template #sub-title>
          <div class="text-center">
            초대 받은 친구들이 가입할 때마다<br />
            적립금 500원을 받아요.
          </div>
        </template>
        <template #content>
          <InviteNote
            note-type="invite"
            class="content"
          />
        </template>
      </ImageMessageBlock>
      <div class="buttons w-full flex gap-8 p-16">
        <CtaButton
          id="gtm_invite_link_btn"
          size="lg"
          w-full
          type="secondary"
          text="링크 복사하기"
          :tabindex="-1"
          @click-button="handleCopyLink"
        />
        <CtaButton
          id="gtm_invite_send_btn"
          w-full
          size="lg"
          text="친구 초대하기"
          @click-button="handleInviteButton"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { referralApi } = useApi()
const config = useRuntimeConfig()
const { message } = useAlarm()
const route = useRoute()
const { isLoginStatus } = storeToRefs(useAuthStore())
const { redirectPath } = storeToRefs(useRedirectStore())

definePageMeta({
  layout: 'center'
})

useSeoMeta({
  title: '유심사로 친구 초대하기',
  description:
    '친구를 유심사에 초대하면 해외 데이터 eSIM 할인과 적립금 혜택을 드려요. 간편한 링크 공유로 여행 준비도 함께하세요!'
})

const referralLink = ref('')

onMounted(async () => {
  if (isLoginStatus.value) {
    referralLink.value = (await getReferralCodeLink()) ?? ''
  }
})

const getReferralCodeLink = async () => {
  try {
    const res = await referralApi.getReferralCode()
    if (!res.data) {
      throw new Error('No referral code received')
    } else {
      const link = config.public.baseUrl + `/invite/receive?referral=${res.data}`
      return link
    }
  } catch (error) {
    console.error(error)
    message('info', '초대코드 생성 중 오류가 발생했습니다.', false, true, 2000, 90, 'message-plain')
    return ''
  }
}

const handleShareLink = () => {
  if (!isLoginStatus.value) {
    redirectPath.value = route.path
    navigateTo('/user')
    return
  }

  if (!referralLink.value) {
    message('info', '잠시 후 다시 시도해주세요.', false, true, 2000, 90, 'message-plain')
    getReferralCodeLink()
    return
  }

  if (useAppCheck().isApp) {
    const intappversioin = parseInt(useAppCheck().appVersion.replaceAll('.', ''))

    if (window.flutter_inappwebview && intappversioin >= 213) {
      window.flutter_inappwebview!.callHandler(
        'shareHandler',
        window.document.title,
        '',
        referralLink.value
      )
    } else {
      useClipboard().copy(referralLink.value)
      message('info', '링크가 복사되었어요.', false, true, 2000, 90, 'message-plain')
    }
  } else {
    useClipboard().copy(referralLink.value)
    message('info', '링크가 복사되었어요.', false, true, 2000, 90, 'message-plain')
  }
}

const handleCopyLink = () => {
  if (!isLoginStatus.value) {
    redirectPath.value = route.path
    navigateTo('/user')
    return
  }

  if (!referralLink.value) {
    message('info', '잠시 후 다시 시도해주세요.', false, true, 2000, 90, 'message-plain')
    getReferralCodeLink()
    return
  }

  useClipboard().copy(referralLink.value)
  message('info', '링크가 복사되었어요.', false, true, 2000, 90, 'message-plain')
}

const handleInviteButton = async () => {
  if (!isLoginStatus.value) {
    redirectPath.value = route.path
    navigateTo('/user')
    return
  }
  const link = referralLink.value ? referralLink.value : await getReferralCodeLink()

  // use Web Share API to share the link
  try {
    if (navigator.share) {
      navigator.share({
        url: link
      })
    } else {
      handleShareLink()
    }
  } catch (error) {
    console.error('Error sharing:', error)
    message('info', '공유 중 오류가 발생했습니다.', false, true, 2000, 90, 'message-plain')
  }
}
</script>

<style lang="scss" scoped>
.invite-page {
  .buttons {
    position: fixed;
    max-width: 500px;
    bottom: 0;
    background: $base-white;
  }
}
</style>
